/**
 * 路径配置工具
 * 动态获取项目的基础路径，支持从环境变量或URL中提取
 */

/**
 * 从当前URL中提取基础路径
 * xybfb 后面的数字位数不限，支持任意位数的数字
 * @returns {string} 基础路径，如 '/xybfb_pure/'、'/xybfb123_h5/'、'/xybfb12345_h5/' 等
 */
export function getBasePath() {
    // 如果是在浏览器环境中，从URL中提取路径
    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        // 匹配路径格式，例如：/xybfb_pure/ 或 /xybfb123_h5/ 或 /ybfb12_h5（没有尾部斜杠）
        // 使用 /^\/([^/]+)(?:\/|$)/ 来匹配有或没有尾部斜杠的情况
        const match = pathname.match(/^\/([^/]+)(?:\/|$)/);
        if (match && match[1]) {
            return `/${match[1]}/`;
        }
        // 如果没有匹配到，返回默认路径
        return '/xybfb_pure/';
    }

    // 服务端渲染或构建时，使用环境变量或默认值
    const envPath = process.env.VUE_APP_BASE_PATH;
    if (envPath) {
        return `/${envPath}/`;
    }
    return '/xybfb_pure/';
}

/**
 * 获取基础路径（不含首尾斜杠）
 * @returns {string} 基础路径名称
 */
export function getBasePathName() {
    const basePath = getBasePath();
    // 移除首尾斜杠
    return basePath.replace(/^\/|\/$/g, '');
}

/**
 * 构建完整URL
 * @param {string} domain - 域名，如 'https://wen.aisuyuan.com'
 * @param {string} path - 路径，如 'cashier' 或 '/cashier'
 * @param {string} query - 查询字符串，如 'id=123&navType=1'
 * @returns {string} 完整URL
 */
export function buildFullUrl(domain, path, query = '') {
    const basePath = getBasePath();
    const basePathName = getBasePathName();

    // 确保路径以 / 开头，但不包含基础路径
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // 构建完整URL
    const url = `${domain}${basePath}${cleanPath}`;

    // 如果有查询参数，添加查询字符串
    if (query) {
        return query.startsWith('?') ? `${url}${query}` : `${url}?${query}`;
    }

    return url;
}

export default {
    getBasePath,
    getBasePathName,
    buildFullUrl
};